import { z } from 'zod';

const StatusCustodiaEquipamentoEnum = z.enum([
  'estoque_raro',
  'em_transito',
  'em_homologacao',
  'com_colaborador',
  'com_cliente',
  'devolvido',
  'em_configuracao',
  'em_preparo',
  'aguardando_devolucao',
  'em_manutencao',
  'devolvido_cliente',
  'inativo',
]);

const PropriedadeAtivoEnum = z.enum(['raro', 'cliente']);
const OrigemAtivoEnum = z.enum(['manual', 'glpi', 'ocs']);

const AtorSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
  avatar: z.string().nullable().optional(),
});

const textoOpcional = z.string().nullable().optional();

/** Campos da ficha (ver CamposFichaAtivo) — compartilhados por create e update. */
const CamposFichaSchema = z.object({
  patrimonio: textoOpcional,
  nSerie: textoOpcional,
  modelo: textoOpcional,
  fabricante: textoOpcional,
  sistemaOperacional: textoOpcional,
  processador: textoOpcional,
  memoria: textoOpcional,
  tamanhoDisco: textoOpcional,
  colaboradorAtualId: textoOpcional,
  clienteAtualId: textoOpcional,
  propriedade: PropriedadeAtivoEnum.nullable().optional(),
  clienteProprietarioId: textoOpcional,
  projetoClienteId: textoOpcional,
  dataCompra: z.any().nullable().optional(),
  notaFiscalNumero: textoOpcional,
  fornecedor: textoOpcional,
  valor: z.number().nonnegative().nullable().optional(),
  linha: textoOpcional,
  operadora: textoOpcional,
  msin: textoOpcional,
  pin1: textoOpcional,
  puk1: textoOpcional,
  pin2: textoOpcional,
  puk2: textoOpcional,
  numeroCartao: textoOpcional,
});

export const EquipamentoCreateSchema = CamposFichaSchema.extend({
  tipo: z.string().min(1, 'O tipo de equipamento é obrigatório'),
  statusCustodia: StatusCustodiaEquipamentoEnum.optional(),
  situacaoDetalhe: textoOpcional,
  fornecedorManutencao: textoOpcional,
  origem: OrigemAtivoEnum.nullable().optional(),
  glpiItemId: textoOpcional,
  glpiItemType: textoOpcional,
  createdBy: AtorSchema.nullable().optional(),
});

export const EquipamentoUpdateSchema = CamposFichaSchema.extend({
  id: z.string().min(1, 'O ID do equipamento é obrigatório'),
  tipo: z.string().min(1).optional(),
  statusCustodia: StatusCustodiaEquipamentoEnum.optional(),
  situacaoDetalhe: textoOpcional,
  fornecedorManutencao: textoOpcional,
  glpiItemId: textoOpcional,
  glpiItemType: textoOpcional,
  updatedBy: AtorSchema.nullable().optional(),
});

export const AlteracaoSituacaoAtivoSchema = z.object({
  id: z.string().min(1),
  statusCustodia: StatusCustodiaEquipamentoEnum,
  situacaoDetalhe: textoOpcional,
  fornecedorManutencao: textoOpcional,
  motivo: z.string().trim().min(1, 'Informe o motivo da alteração'),
  ator: AtorSchema,
});

export const EquipamentoSchema = CamposFichaSchema.extend({
  id: z.string().min(1),
  tipo: z.string().min(1),
  statusCustodia: StatusCustodiaEquipamentoEnum,
  situacaoDetalhe: textoOpcional,
  fornecedorManutencao: textoOpcional,
  origem: OrigemAtivoEnum.nullable().optional(),
  glpiItemId: textoOpcional,
  glpiItemType: textoOpcional,
  createdAt: z.any(),
  updatedAt: z.any(),
});
